import { GridFilterOperator } from "@mui/x-data-grid-pro";

import { operator } from "types";

import { CustomGridFilterInputSingleSelect } from "./components/CustomGridFilterInputSingleSelect";

export const getGridOptionOperators = (): GridFilterOperator[] => [
  {
    label: "is",
    value: operator.equals,
    getApplyFilterFn: (filterItem) => {
      return (params) => {
        return params === filterItem.value;
      };
    },
    InputComponent: CustomGridFilterInputSingleSelect
  },
  {
    label: "is not",
    value: operator.notEquals,
    getApplyFilterFn: (filterItem) => {
      return (params) => {
        return params !== filterItem.value;
      };
    },
    InputComponent: CustomGridFilterInputSingleSelect
  }
];
